import styled from 'styled-components';

import { SmallParagraph } from '../../../foundations/typefaces/SmallParagraph';

export const LabelIcon = styled.div(({ theme: { size } }) => ({
  width: size.units(2),
}));

export const LabelText = styled(SmallParagraph)(({ theme: { size, color } }) => ({
  maxWidth: size.units(25),
  color: color.content.secondary.default(),
}));

export const TextWrapper = styled.div(({ theme: { size, color } }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: color.content.secondary.default(),
  wordWrap: 'break-word',
  paddingLeft: size.units(1),
  pointerEvents: 'none',
  height: '100%',
  width: '100%',

  [LabelText]: {
    marginLeft: size.units(3),
  },
}));
